import { render, staticRenderFns } from "./AppFormButtons.vue?vue&type=template&id=2493a631"
import script from "./AppFormButtons.vue?vue&type=script&lang=ts"
export * from "./AppFormButtons.vue?vue&type=script&lang=ts"
import style0 from "./AppFormButtons.vue?vue&type=style&index=0&id=2493a631&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports